
export const flags = {
  USD: 'flag-us',
  CAD: 'flag-ca',
  GBP: 'flag-uk',
  AUD: 'flag-au',
  EUR: 'flag-eu',
  SGD: 'flag-sgp',
  MXN: 'flag-mxn'
};

export const _lng = {
  'en-US': {
    label: 'English',
    flag: flags.USD
  },
  'fr-CA': {
    label: 'Français',
    flag: 'flag-fr'
  },
  'mxn-MXN': {
    label: 'Méjico',
    flag: flags.MXN
  }
};

export const currency = {
  USD: '$',
  CAD: '$',
  GBP: '£',
  AUD: '$',
  EUR: '€',
  SGD: '$',
  MXN: '$'
};

// eslint-disable-next-line
export const emailRegexp = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
export const isNumberRegexp = /^\d+$/;
export const isURLRegexp = /^(?!\d*$)([A-z0-9][A-z0-9_\-]*)$/;

export const timeerOffModal = 2500;

export const SummenrNoteToolbar = [
  // [groupName, [list of button]]
  ['style', ['bold', 'underline', 'clear']],
  ['insert', ['link']],
  ['font', ['strikethrough', 'fontsize']],
  ['color', ['backcolor', 'color']],
  ['para', ['ul', 'ol', 'paragraph']],
  ['height', ['height']]
];

export const SummenrNoteToolbarHeight10Lines = 250;

export const encryptKey = 'sparxo*!*';

/** FeeType */
export const TicketFeeType = {
  IncludeFee: 'IncludeFee', // 1
  ExcludeFee: 'ExcludeFee' // 2
};

export const MaxOrderQuantity = 50;

export const AssignEventPermission = {
  Read: 'Read',
  Write:'Write'
};

// export const QuestionAskTo = consts.QuestionAskTo;
// export const QuestionDisplayType = consts.QuestionDisplayType;
// export const FacebookPageShareUrlWay = consts.FacebookPageShareUrlWay;
// export const RewardItem = consts.RewardItem;
// export const RewardAccordingTo = consts.RewardAccordingTo;
export const Months = [
  {
    id: 1,
    text: 'January'
  },
  {
    id: 2,
    text: 'February'
  },
  {
    id: 3,
    text: 'March'
  },
  {
    id: 4,
    text: 'April'
  },
  {
    id: 5,
    text: 'May'
  },
  {
    id: 6,
    text: 'June'
  },
  {
    id: 7,
    text: 'July'
  },
  {
    id: 8,
    text: 'August'
  },
  {
    id: 9,
    text: 'September'
  },
  {
    id: 10,
    text: 'October'
  },
  {
    id: 11,
    text: 'November'
  },
  {
    id: 12,
    text: 'December'
  }
];



// WEBPACK FOOTER //
// ./src/consts/Checkout.ts